import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import * as fromReducer from './../state/reducers/recaptcha.reducer';
import * as fromSelectors from './../state/selectors/spinner.selector';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';

const SPINNER_MESSAGE = 'Loading...';

@Component({
	selector: 'ats-spinner',
	templateUrl: './spinner.component.html',
	styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {
	constructor(private spinner: NgxSpinnerService,
		private store: Store<fromReducer.State>) { }
	private $show: Observable<boolean>;
	ngOnInit() {
		this.$show = this.store.pipe(select(fromSelectors.Show));
		this.$show.subscribe(show => {
			if (show) {
				this.spinner.show();
			}
			else {
				this.spinner.hide();
			}
		});
	}

}
